<template>
  <ReportContentModal
    v-bind:card="selectedPreviewCard"
    v-bind:page="reportingPage"
    v-on:ok="$emit('ok')"
    v-on:cancel="$emit('cancel')"
  />
</template>

<script>
  import { mapGetters } from 'vuex';
  import { isNil, isEmpty } from 'lodash';

  export default {
    name: 'report-content-from-preview',

    computed: {
      ...mapGetters([
        'selectedPreviewPageIndex',
        'selectedPreviewCard',
      ]),

      reportingPage() {
        if (!isNil(this.selectedPreviewCard) &&
            !isNil(this.selectedPreviewCard.pages) &&
            !isEmpty(this.selectedPreviewCard.pages) &&
            !isNil(this.selectedPreviewPageIndex) &&
            !isNil(this.selectedPreviewCard.pages[this.selectedPreviewPageIndex])) {
          return this.selectedPreviewCard.pages[this.selectedPreviewPageIndex];
        }

        return null;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ReportContentFromPreview.vue